import Header from './components/Header';
import Products from './components/Products';
import './index.css';

function App() {
  return (
    <div className="App">
      <Products />
    </div>
  );
}

export default App;
